export const styleXl = {
  parentBox: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  contentBox: {
    height: "30vh",
    width: "50vw",
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "70%",
  },
  imgSize: { width: "100%", height: "100%" },
  firstTextStyle: {
    fontSize: "2.5vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
  secondTextStyle: {
    fontSize: "1.5vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
};

export const styleLg = {
  parentBox: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  contentBox: {
    height: "30vh",
    width: "50vw",
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "70%",
  },
  imgSize: { width: "100%", height: "100%" },
  firstTextStyle: {
    fontSize: "2.5vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
  secondTextStyle: {
    fontSize: "1.5vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
};

export const styleMd = {
  parentBox: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  contentBox: {
    height: "30vh",
    width: "50vw",
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "70%",
  },
  imgSize: { width: "100", height: "100%" },
  firstTextStyle: {
    fontSize: "5vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
  secondTextStyle: {
    fontSize: "2vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
};

export const styleSm = {
  parentBox: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  contentBox: {
    height: "30vh",
    width: "80vw",
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "70%",
  },
  imgSize: { width: "100%", height: "100%" },
  firstTextStyle: {
    fontSize: "7vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
  secondTextStyle: {
    fontSize: "3vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
};

export const styleXs = {
  parentBox: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  contentBox: {
    height: "30vh",
    width: "90vw",
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "65%",
  },
  imgSize: { width: "100%", height: "100%" },
  firstTextStyle: {
    fontSize: "10vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
  secondTextStyle: {
    fontSize: "4vw",
    color: "#808080",
    textAlign: "center",
    fontFamily: "MontserratBold",
  },
};
